<app-header-step [queryParams]='queryParams' [user]='user' step='4'
                 (updateInformation)='updateInformation(0)'></app-header-step>

<div class='row' style='width: 100%'>
  @if (isOAV) {
    <app-preconisation-oav [state]='state' [user]='user' (next)='nextStep($event)'
                           [caisse]='caisse'></app-preconisation-oav>
  }
  @if (!isOAV) {
    <app-preconisation-selfcare></app-preconisation-selfcare>
  }
</div>

